/**
 * Generated bundle index. Do not edit.
 */

export * from './color-public-api';
